import { AbstractStockProvider, StockList, ReasonList, AccessTokenResponse, TickerDataResponse, TickerDataPoint, TickersResponse } from './types';

// Assuming AbstractStockProvider is defined somewhere in your project

export class StockProvider implements AbstractStockProvider {

  private baseUrl: string;
  private serverUrl: string;

  constructor() {
    this.serverUrl = process.env.REACT_APP_ENVIRONMENT === 'production' ?'https://api.tickertribe.com': "http://localhost:4000";
    // this.serverUrl = "http://localhost:4000";
    this.baseUrl = this.serverUrl + '/stockTracker';
  }
  
  async getMomentumStocks(date: string) {
    // Fetch data from API
    const response = await fetch(`${this.baseUrl}/momentumStocks/${date}`);
    const data = await response.json();
    return data as Promise<StockList>;
  }

  async getTrendingStocks(date: string) {
    // Fetch data from API
    const response = await fetch(`${this.baseUrl}/trendingStocks/${date}`);
    const data = await response.json();
    return data as Promise<StockList>;
  }

  async getStockMovements() {
    // Fetch data from API
    const response = await fetch(`${this.baseUrl}/stockMovements`);
    const data = await response.json();
    return data as Promise<StockList>;
  }

  async GetStockReasoning(date: string, symbol: string, runner_type: string) {

    var url = `${this.baseUrl}/getReasons?`;
    if (date) {
      url += `&businessDay=${date}`;
    }
    if (symbol) {
      url += `&symbol=${symbol}`;
    }

    if (runner_type) {
      url += `&runner_type=${runner_type}`;
    }

    // Fetch data from API
    const response = await fetch(url);
    const data = await response.json();
    return data as Promise<ReasonList>;
  }

  async GetAccessToken(api_key: string, api_secret: string) {
    // Fetch data from API
    const response = await fetch(`${this.serverUrl}/stockData/generateAccessToken`, {
      method: 'POST',
      // headers: {
      //   'Content-Type': 'application/json',
      // },
      body: JSON.stringify({
        apiKey: api_key,
        apiSecret: api_secret
      }),
    });
    const data = await response.json();
    console.log("data from provider", data);
    return data as Promise<AccessTokenResponse>;
  }

  async DownloadStockData(
    isin: string,
    interval: string,
    startDate: string,
    endDate: string,
    accessToken: string
  ): Promise<Blob> {
    const response = await fetch(
      `${this.serverUrl}/stockData/download/csv/1d/${isin}?startDate=${startDate}&endDate=${endDate}`,
      {
        method: 'GET',
        headers: {
          'accessToken': accessToken
        }
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to download data: ${response.statusText}`);
    }

    return response.blob();
  }

  async getTickerData(
    isin: string,
    interval: string,
    startDate: string,
    endDate: string,
    accessToken: string
  ): Promise<TickerDataResponse> {
    let url = `${this.serverUrl}/stockData/getStockData/${interval}/${isin}`;
    
    const queryParams = new URLSearchParams();
    
    queryParams.append('startDate', startDate);
    queryParams.append('endDate', endDate);

    const queryString = queryParams.toString();
    if (queryString) {
      url += `?${queryString}`;
    }

    const response = await fetch(url, {
      headers: {
        'accessToken': accessToken
      }
    });
    
    if (response.status === 401) {
      return { status: '401', data: [] };
    }
    
    if (!response.ok) {
      throw new Error(`Failed to fetch ticker data: ${response.statusText}`);
    }
    
    const rawData = await response.json();
    
    // Transform the raw data into the typed format
    const transformedData: TickerDataResponse = {
      data: rawData.data.map((point: [number, number, number, number, number, number]): TickerDataPoint => ({
        timestamp: point[0],
        open: point[1],
        high: point[2],
        low: point[3],
        close: point[4],
        volume: point[5]
      })),
      status: rawData.status
    };

    return transformedData;
  }

  async getTickers(accessToken: string, type?: string, exchange?: string): Promise<TickersResponse> {
    let url = `${this.serverUrl}/stockData/getTickers`;
    
    const queryParams = new URLSearchParams();
    if (type) {
      queryParams.append('type', type);
    }
    if (exchange) {
      queryParams.append('exchange', exchange);
    }

    const queryString = queryParams.toString();
    if (queryString) {
      url += `?${queryString}`;
    }

    const response = await fetch(url, {
      headers: {
        'accessToken': accessToken
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch tickers: ${response.statusText}`);
    }

    const data = await response.json();
    
    // Validate response structure
    if (!data.status || !Array.isArray(data.data)) {
      throw new Error('Invalid response structure from tickers endpoint');
    }

    return data as TickersResponse;
  }
}